/**
 * Private modules
 */
import { reducers } from '../.private';

export default reducers;
